// First name derived from an email's local part:
//   "edwin.owusu92@gmail.com" -> "Edwin"
// Used for the personalised dashboard heading and the admin nudge messages.
export function ownerFirstName(email?: string | null): string {
  const local = (email || '').split('@')[0] || '';
  const first = local.split(/[._\-+\d]+/).filter(Boolean)[0] || '';
  return first ? first.charAt(0).toUpperCase() + first.slice(1).toLowerCase() : '';
}
